import { post } from '@dark-portal/react-infrastructure';
import { getIdentityConfig } from '../config';

let pendingRefresh: Promise<void> | null = null;

const request = async (): Promise<void> => {
  const { request } = post({
    url: `${getIdentityConfig().apiUrl}/identity/auth/refresh`,
  });

  await request;
};

export function refreshRequest(): Promise<void> {
  if (!pendingRefresh) {
    pendingRefresh = request().finally(() => {
      pendingRefresh = null;
    });
  }

  return pendingRefresh;
}
